// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCardList_container___N-wU","sending":"ArticleCardList_sending__2MiEZ"};